var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("p", [_vm._v(_vm._s(_vm.description))]),
      _vm._v(" "),
      _vm._l(_vm.visas, function (visa) {
        return _c(
          "div",
          { key: visa.id },
          [
            _c("Input", {
              attrs: {
                name: visa.id,
                label: `${visa.name} - ${_vm.currency(visa.price)}`,
                placeholder: "Please select",
                required: true,
                startingValue: _vm.startingValue(visa),
                options: [
                  _vm.visaOptions.required,
                  _vm.visaOptions.notRequired,
                ],
                vuexPath: _vm.vuexPath,
              },
            }),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }